<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<p style="text-align: center; margin-top: 150px;">One futile gesture is as good as another if the<br/>
audience is unable or unwilling to pay attention.</p>
<br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?0a3fdd72